const container = document.querySelector('#my-account-dropdown-container');

const button = document.querySelector('#my-account-dropdown-btn');

const toggleDropdown = () => {
    container.classList.toggle('active');
};

button?.addEventListener('click', toggleDropdown);
